<template>
  <div class="page">
        <div class="page-content">
            <div data-cy="list_collect_point_inputs">
                <InputCollectPoint
                    v-model:inputValue="codes[i]"
                    v-for="(code, i) in codes"
                    :key="i"
                    :errorInfo="errorInfo[i]"
                    :inputIndex="i"
                    :inputLbl="lbl.collect_point.input"
                    :isShowError="isShowError"
                    :isShowRemove="i > 4"
                    :isSubmitted="isSubmitted"
                    :minLength="10"
                    :maxLength="10"
                    @onRemove="removeInput($event)" />
            </div>
            <div class="grid grid-cols-2 gap-4 mb-6">
                <SecondaryButton
                    btnId="add_input_btn"
                    :btnMsg="lbl.collect_point.add_input"
                    data-cy="btn_collect_point_add_input"
                    @onClick="addInput()" />
                <div>
                    <SecondaryButton
                        btnId="scan_btn"
                        :btnMsg="lbl.collect_point.scan_btn"
                        data-cy="btn_collect_point_scan"
                        @onClick="scan()" />
                    <input
                        type="file"
                        ref="file-scan"
                        class="hidden"
                        data-cy="input_collect_point_scan_file"
                        @change="onSelectFile($event)" />
                </div>
            </div>

            <PrimaryButton
                btnId="submit_btn"
                :btnMsg="lbl.collect_point.submit_btn"
                data-cy="btn_collect_point_submit"
                @onClick="onSubmit()" />
      </div>
      <div class="page-bg"></div>

      <ModalMaster :controller="modalController"></ModalMaster>
  </div> 
</template>
<script>
// helper
import { ErrorInfo, FormHelper } from "@/helper/FormHelper.js";
// mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
// component
import InputCollectPoint from "../component/InputCollectPoint.vue";
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
import SecondaryButton from "@/components/Button/SecondaryButton.vue";
// service
import BzbsCollectPoint from "@/core/CollectPoint/service/BzbsCollectPoint.js";
export default {
    name: "CollectPoint",
    mixins: [ErrorApiMixin, LocaleMixin, ModalMixin],
    components: {
        InputCollectPoint,
        PrimaryButton,
        SecondaryButton
    },
    computed: {
        currentInputAmount: function() {
            return this.codes.length;
        }
    },
    data: function() {
        return {
            // config
            minInputAmount: 5,
            maxInputAmount: 10,
            // collect point
            codes: ["1111111111", "1111111111", "1111", "", ""],
            errorInfo: [],
            isShowError: false,
            isSubmitted: false
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(5);
    },
    methods: {
        //#region input
        addInput: function(newCode) {
            if (this.currentInputAmount == this.maxInputAmount) return;

            let code = newCode || "";
            // add code
            this.codes.push(code);
            // add error
            const errorInfoItem = new ErrorInfo();
            this.errorInfo.push(errorInfoItem);
        },
        removeInput: function(index) {
            if (this.currentInputAmount == this.minInputAmount) return;

            // remove code
            this.codes.splice(index, 1);
            // remove code
            this.errorInfo.splice(index, 1);
        },
        //#endregion input
        //#region scan flow
        scan: function () {
            this.$refs["file-scan"].value = "";
            this.$refs["file-scan"].click();
        },
        onSelectFile: function(file) {
            const selectedFile = file.target.files[0];
            if (!this.validateFile(selectedFile)) return;

            this.modalController.loadingModal.show();
            BzbsCollectPoint.apiGetCodeByQRCode(selectedFile).subscribe({
                next: res => {
                    this.modalController.loadingModal.hide();

                    const codes = res;
                    if (codes.length == 0) {
                        // No codes
                        this.showErrorModal(this.lbl.collect_point.error_title, this.lbl.collect_point.error_message_scan, this.lbl.collect_point.error_btnOk);
                    } else {
                        this.fillCode(codes);
                    }
                },
                error: err => {
                    this.modalController.loadingModal.hide();
                    this.errorApi(err);
                }
            });
        },
        fillCode: function(newCodes) {
            // Get available input index and amount (not include addable input).
            const availableInput = this.getAvailableInputIndex();
            let availableInputCount = availableInput.count;
            let availableInputCounter = 0;
            let availableInputIndex = availableInput.index;
            for (let code of newCodes) {
                if (availableInputCounter < availableInputCount) {
                    this.codes[availableInputIndex] = code;
                    availableInputCount++;
                } else if (this.currentInputAmount <= this.maxInputAmount) {
                    this.onAddInput(code);
                }
            }
        },
        //#endregion scan flow
        //#region collect point flow
        onSubmit: async function() {
            this.isSubmitted = true;
            this.isShowError = true;
            // Check input error.
            const isValid = FormHelper.validate(this.errorInfo);
            // Check is one or input filled.
            const isInputFilled = this.codes.filter(code => code);
            if (isInputFilled.length > 0) {
                // check duplicate before call api.
                const isDuplicate = this.validateDulplicateCode();
                if (isDuplicate || !isValid) return;
                // call api.
                let collectPointResult = await this.apiCollectPoint();
                if (!collectPointResult) return;

                const earned_point = this.mapCollectPointResult(collectPointResult);
                if (earned_point > 0) {
                    // show popup.
                }
            } else {
                // No code fill do nothing.
                this.showErrorModal(this.lbl.collect_point.error_title, this.lbl.collect_point.error_message_empty, this.lbl.collect_point.error_btnOk);
            }
        },
        validateDulplicateCode: function() {
            let isDuplicate = false;
            for (let [index, code] of this.codes.entries()) {
                const duplicateCode = this.codes.filter((item, filterIndex) => {
                    if (code && code === item && index != filterIndex) {
                        this.setErrorInfoByIndex(filterIndex, false, this.lbl.collect_point.input.duplicate);
                        return code;
                    }
                });

                if (duplicateCode.length > 0) {
                    isDuplicate = true;
                }
            }

            return isDuplicate;
        },
        validateFile: function(file) {
            const isValid =
                file.type == "image/jpeg" ||
                file.type == "image/jpg" ||
                file.type == "image/png";
            if (!isValid) {
                this.modalComtroller.alertModal.hide();
            }

            return isValid;
        },
        //#endregion collect point flow
        //#region service
        apiCollectPoint: function() {
            return new Promise((resolve) => {
            this.modalController.loadingModal.show();
                BzbsCollectPoint.apiCollectPoint().subscribe({
                    next: res => {
                        this.modalController.loadingModal.hide();

                        resolve(res);
                    },
                    error: err => {
                        this.modalController.loadingModal.hide();
                        this.errorApi(err, error => {
                            switch (error.id) {
                                case '403':
                                    // Ban from enter wrong code.
                                    this.showErrorModal(this.lbl.collect_point.error_title, this.lbl.collect_point.error_message_block, this.lbl.collect_point.error_btnOk); 
                                    break;
                                default:
                                    this.showErrorModal(this.lbl.collect_point.error_title, error.message, this.lbl.collect_point.error_btnOk); 
                                    break;
                            }
                        });

                        resolve(null);
                    }
                });
            });
        },
        //#endregion service
        //#region utility
        getAvailableInputIndex: function() {
            let count = 0;
            let index = [];
            this.codes.filter((item, index) => {
                if (!item) index.push(index);
            });

            return {
                count: count,
                index: index
            };
        },
        mapCollectPointResult: function(codeResult) {
            return new Promise((resolve) => {
                let earnedPoint = 0;
                for (let [index, code] of codeResult.entries()) {
                    const status = code.status 
                        ? code.status.toLowerCase() 
                        : code.status;
                    switch (status) {
                        case 'notfound':
                            this.setErrorInfoByIndex(index, false, this.lbl.collect_point.input.invalid)
                            break;
                        case 'used':
                            this.setErrorInfoByIndex(index, false, this.lbl.collect_point.input.duplicate)
                            break;
                        case 'success':
                            this.codes[index] = '';
                            earnedPoint += code.points_earn;
                            break;
                        default:
                            break;
                    }
                }

                resolve(earnedPoint);
            });
        },
        setErrorInfoByIndex: function (index, isValid, msg) {
            this.errorInfo[index].setValid(isValid);
            this.errorInfo[index].setMsg(msg);
        },
        //#endregion utility
        //#region modal
        showErrorModal: function(title, message, btnOK) {
            this.modalController.alertModal
                .clearModal()
                .setTitle(title)
                .setMsg(message)
                .setBtnOk(btnOK)
                .show();
        }
        //#endregion modal
    }
}
</script>